export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/hatchback.fc825f35.svg","height":37,"width":88,"blurWidth":0,"blurHeight":0};